module.exports = __webpack_public_path__ + "img/bck-arr-mob-head.10795106.svg";